<script setup>
import { computed } from 'vue';
import AppIcon from '@/Components/UI/AppIcon.vue';
import { dismissSessionNotice, sessionNotice } from '@/utils/sessionRecovery';

/** Global notice for requests rejected with 419/401; see utils/sessionRecovery.js. */
const message = computed(() => {
    switch (sessionNotice.kind) {
        case 'retry':
            return 'Nothing was saved because this page’s session had changed. It has been refreshed and your changes are still here. Please try again.';
        case 'signed_out':
            return 'You have been signed out (the session expired or you signed out in another tab). Nothing was saved and your changes are still on this page. Sign in using the link below, which opens a new tab, then come back and try again.';
        case 'unknown':
            return 'Nothing was saved and the session could not be checked. Your changes are still on this page. Check your connection, then try again.';
        default:
            return '';
    }
});
</script>

<template>
    <div
        v-if="sessionNotice.kind"
        data-session-notice
        role="alert"
        class="fixed left-1/2 top-3 z-[70] grid w-[min(34rem,calc(100vw-1rem))] -translate-x-1/2 grid-cols-[1fr_auto] gap-2 rounded-surface border border-line-strong border-l-4 border-l-brand bg-surface py-3 pl-3.5 pr-2 shadow-overlay"
    >
        <div class="space-y-2">
            <p class="text-sm text-ink">{{ message }}</p>
            <a
                v-if="sessionNotice.kind === 'signed_out'"
                href="/login"
                target="_blank"
                rel="noopener"
                class="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-strong underline underline-offset-2"
            >
                Sign in (opens a new tab)
            </a>
        </div>
        <button
            type="button"
            class="inline-flex h-7 w-7 items-center justify-center rounded-control text-muted hover:bg-hover hover:text-ink"
            aria-label="Dismiss"
            @click="dismissSessionNotice"
        >
            <AppIcon name="x" :size="16" />
        </button>
    </div>
</template>
